import { Injectable } from '@angular/core';
import { ContextService } from './context.service';

@Injectable()
export class PeProviderService {

  private _data: { name: string, code: number }[] = [
    { name: 'ΑΡΓΟΛΙΔΑΣ', code: 11 },
    { name: 'ΑΡΚΑΔΙΑΣ', code: 12 },
    { name: 'ΚΟΡΙΝΘΙΑΣ', code: 15 },
    { name: 'ΛΑΚΩΝΙΑΣ', code: 17 },
    { name: 'ΜΕΣΣΗΝΙΑΣ', code: 16 }
  ];

  constructor(private app: ContextService) {
    // app.placesUpdated();
  }

  get data() {
    return Promise.resolve(this._data);
  }

}



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-data-entry/src/app/services/pe-provider.service.ts